import React, { useState } from "react";
import { Button, Col, Container, Form, FormControl, Image, InputGroup, Row } from "react-bootstrap";
import "../../Assets/css/footer.css";
import { Link, NavLink } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material/";
import {
  Address_details,
  Email_details,
  Theme,
  client_name,
  contact_number,
  helmet_url,
  media_details,
  base_url,
  postHeader
} from "../../Helpers/request";
import { isDesktop, isMobileOnly } from "react-device-detect";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import recommendsImg from '../Front/themes/showcase/assets/images/footer-img/recommends.png';
import knotImg from '../Front/themes/showcase/assets/images/footer-img/the-knot.png';
import naja from '../Front/themes/showcase/assets/images/footer-img/f-logos/naja.png';
import stuller from '../Front/themes/showcase/assets/images/footer-img/f-logos/stuller.png';
import gia from '../Front/themes/showcase/assets/images/footer-img/f-logos/gia.png';
import association from '../Front/themes/showcase/assets/images/footer-img/f-logos/d-association.png';
import jAmerica from '../Front/themes/showcase/assets/images/footer-img/f-logos/j-america.jpg';
import jbt from '../Front/themes/showcase/assets/images/footer-img/f-logos/jbt.png';
import jm from '../Front/themes/showcase/assets/images/footer-img/f-logos/jm.png';
import ma_boston from '../Front/themes/showcase/assets/images/footer-img/f-logos/ma_boston_jewelers_2021_transparent.webp';


import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";


const Footer = () => {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const history = useHistory();
  const currencycode = useSelector(
    (state) => state.persistedReducer.home.currencycode
  );
  const [newsletteremail, setNewsletteremail] = useState("");
  const [loader, setLoader] = useState(false);
  const newsletter = (e) => {
    e.preventDefault();
    setLoader(true);
    const data = {
      currency_code: currencycode,
      email: newsletteremail,
    };
    axios
      .post(base_url + "/common/subscribe_newsletter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setNewsletteremail("");
          return swal(res.data.message, "", "success");
        } else {
          setLoader(false);
          return swal(res.data.message, "", "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };


  return (
    <div role="contentinfo">
        <div className={`${Theme}_footer`}>
          <div className="rcs_footer" id="rcs_footer">
            <Container
              fluid
              className="showcase-container rcs_custom_home_container"
            >
              <div className="d-none d-lg-block">
                <Row className="justify-content-between">
                  <Col xs={12} sm={6} md={12} lg={3}>
                    <div className="rcs_footer_content_one ">
                      {/* <div className="logo">
                        <NavLink to="/">
                          <Image
                            height="60"
                            style={{ marginLeft: "-6px" }}
                            src={`${ImageUrl}white-logo.png`}
                            alt={client_name.c_name}
                          />
                        </NavLink>
                      </div> */}
                      <div className="rcs_footer_content rcs_info">
                        <h2 className="mb-3">About Us</h2>
                      </div>
                      <p>
                        {client_name.c_name}  is an eminent name
                        in the field of the Diamond industry.
                        With an experience of over 33 years,
                        we revolutionized the industry with a
                        disruptive online business model.
                        <NavLink to="/our-story">Read More ...</NavLink>
                      </p>
                      <ul className="d-flex justify-content-left align-items-center">
                        {media_details.map((media, id) => (
                          <li key={id}>
                            <div className="rcs_footer_content_one_social_icn_div">
                              <a href={media.account_link} target="_blank" rel="noreferrer" aria-label={`Visit our ${media.account_alt} page`}>
                                {media.account_icon}
                                <span className="sr-only">
                                  {`Visit our ${media.account_alt}`}
                                </span>
                              </a>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>

                  </Col>
                  <Col xs={12} sm={6} md={6} lg={2}>
                    <div className="rcs_footer_content rcs_info">
                      <h2 className="mb-3">Policies</h2>
                      <ul className="rcs_footer_list">
                        <li>
                          <NavLink to="/our-story">About Us</NavLink>
                        </li>
                        {/* <li><NavLink to="#">Cookie Policy</NavLink></li> */}
                        <li>
                          <NavLink to="/privacy-policy">
                            Privacy Policy
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/terms-and-conditions">
                            Terms & Condition
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/contact">Contact Us</NavLink>
                        </li>
                        <li>
                          <NavLink to="/make-an-appointment">
                            Virtual Appointment
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    md={6}
                    lg={3}
                    className="d-flex justify-content-end"
                  >
                    <div className="rcs_footer_content">
                      <h2 className="mb-3">Get in Touch</h2>
                      <ul className="rcs_footer_list">
                        {/* <p className='mt-0'>Address: </p> */}
                        <li
                          onClick={() => {
                            window.open(Address_details.link, "_blank");
                          }}
                        >

                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                          </svg>

                          {Address_details.textLine1}
                          <br />
                          {Address_details.textLine2}
                        </li>

                        <li
                          onClick={(e) => {
                            window.location.href = contact_number.link;
                          }}
                        >

                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5317 12.4724C15.5208 16.4604 16.4258 11.8467 18.9656 14.3848C21.4143 16.8328 22.8216 17.3232 19.7192 20.4247C19.3306 20.737 16.8616 24.4943 8.1846 15.8197C-0.493478 7.144 3.26158 4.67244 3.57397 4.28395C6.68387 1.17385 7.16586 2.58938 9.61449 5.03733C12.1544 7.5765 7.54266 8.48441 11.5317 12.4724Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                          </svg>


                          {contact_number.text}
                        </li>
                        <li
                          onClick={(e) => {
                            window.location.href = Email_details.link;
                          }}
                        >

                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.9026 8.85107L13.4593 12.4641C12.6198 13.1301 11.4387 13.1301 10.5992 12.4641L6.11841 8.85107" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9089 21C19.9502 21.0084 22 18.5095 22 15.4384V8.57001C22 5.49883 19.9502 3 16.9089 3H7.09114C4.04979 3 2 5.49883 2 8.57001V15.4384C2 18.5095 4.04979 21.0084 7.09114 21H16.9089Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                          </svg>

                          {Email_details.text}
                        </li>

                      </ul>
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    sm={6}
                    md={6}
                    lg={4}
                    className="d-flex justify-content-end"
                  >
                    <div className="rcs_footer_content">
                      <h2 className="mb-3">Store Open Hours</h2>
                      <ul className="rcs_footer_list">
                        <li>
                          Mon - Fri: 10:30 AM - 6:00 PM
                        </li>
                        <li>Sat: 10:00 AM - 6:00 PM</li>
                        <li>Sun: Closed</li>
                      </ul>

                      <h2 className="mt-3">Subscribe To Our Newsletter</h2>
                      <div className="rcs_signup_to_input_field">
                        <Form className="gs_news_form w-100" onSubmit={newsletter}>
                          <InputGroup>
                            <FormControl
                              aria-label="Recipient's username"
                              type="email"
                              value={newsletteremail}
                              placeholder="Email address"
                              required
                              onChange={(e) => setNewsletteremail(e.target.value)}
                            />
                            <Button
                              className="btn outline-base-btn large"
                              type="submit"
                              id="button-addon2"
                            >
                              Subscribe
                            </Button>
                          </InputGroup>
                        </Form>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <div className=" footer_logo_box1">
                    <a href="javascript:void(0);"><Image src={recommendsImg} className="img-fluid" alt='certified logo' /></a>
                    <a href="javascript:void(0);">  <Image src={knotImg} className="img-fluid" alt='certified logo' /></a>
                    </div>
                    <div className="footer_logo_box2">
                      <a href="https://www.najaappraisers.com/"><Image src={naja} className="img-fluid" alt='certified logo' /> </a>
                      <a href="https://www.stuller.com/"><Image src={stuller} className="img-fluid" alt='certified logo' /> </a>
                      <a href="https://www.gia.edu/"><Image src={gia} className="img-fluid" alt='certified logo' /></a>
                      <a href="javascript:void(0);"><Image src={association} className="img-fluid" alt='certified logo' /></a>
                      <a href="https://www.jewelers.org/"><Image src={jAmerica} className="img-fluid" alt='certified logo' /> </a>
                      <a href="javascript:void(0);"><Image src={jbt} className="img-fluid" alt='certified logo' />  </a>
                      <a href="javascript:void(0);"><Image src={jm} className="img-fluid" alt='certified logo' /> </a>
                      <a href="https://www.expertise.com/self-care-and-style"><Image src={ma_boston} className="img-fluid" alt='certified logo' /></a>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
          <section className="d-lg-none d-md-block rcs_mobile_footer_section">
            <Container>
              <div className="gs_footer_content d-lg-none d-md-block  ">
                <Row className="m-0 w-100">
                  {/* <Col xs={12}>
                    <div className="rcs_footer_content_one ">
                      <div className="logo">
                        <NavLink to="/">
                          <Image
                            height="52"
                            src={`${ImageUrl}white-logo.png`}
                            alt={client_name.c_name}
                          />
                        </NavLink>
                      </div>
                      <p>
                        {client_name.c_name}  is an eminent name
                        in the field of the Diamond industry.
                        With an experience of over 33 years,
                        we revolutionized the industry with a
                        disruptive online business model.
                        Read more...

                        <NavLink to="/our-story">Read More ...</NavLink>
                      </p>
                    </div>
                    <div className="rcs_footer_content_one_social_icn">
                  <ul>
                    {
                      media_details.map((media) =>
                        <li>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target='_blank' rel="noreferrer">{media.account_icon}</a>
                          </div>
                        </li>
                      )}
                  </ul>
                </div>
                  </Col> */}


                  {
                    isMobileOnly &&
                    <Container>
                      <Row>
                        <Col sm={12} md={12} lg={12}>
                          <div className="rcs_footer_content_one ">


                            <ul className="d-flex justify-content-center align-items-center">
                              {media_details.map((media, id) => (
                                <li key={id} >
                                  <div className="rcs_footer_content_one_social_icn_div">
                                    <a href={media.account_link} target="_blank" aria-label={`Visit our ${media.account_alt} page`} rel="noreferrer">
                                      {media.account_icon}
                                      <span className="sr-only">
                                      {`Visit our ${media.account_alt} page`}
                                      </span>
                                    </a>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </Container>

                  }

                  <Accordion
                    expanded={expanded === "panel1"}
                    onChange={handleChange("panel1")}
                  >
                    <AccordionSummary
                      expandIcon={expanded === "panel1" ? <AiOutlineMinus /> : <AiOutlinePlus />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className="footer-mobile-heading">About Us</span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          <ul className="rcs_footer_list contact-foter2">
                            <li>
                              <p>
                                {client_name.c_name}  is an eminent name
                                in the field of the Diamond industry.
                                With an experience of over 33 years,
                                we revolutionized the industry with a
                                disruptive online business model.

                                <NavLink to="/our-story"> Read More ...</NavLink>
                              </p>
                            </li>
                          </ul>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChange("panel2")}
                  >
                    <AccordionSummary
                      expandIcon={expanded === "panel2" ? <AiOutlineMinus /> : <AiOutlinePlus />}
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className="footer-mobile-heading">Policies</span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          <ul className="rcs_footer_list contact-foter2">
                            <li>
                              <NavLink to="/our-story">About Us</NavLink>
                            </li>
                            {/* <li><NavLink to="#">Cookie Policy</NavLink></li> */}
                            <li>
                              <NavLink to="/privacy-policy">
                                Privacy Policy
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/terms-and-conditions">
                                Terms & Condition
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/contact">Contact Us</NavLink>
                            </li>
                            <li>
                              <NavLink to="/make-an-appointment">
                                Virtual Appointment
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  {/* <Accordion
                    expanded={expanded === "panel3"}
                    onChange={handleChange("panel3")}
                  >
                    <AccordionSummary
                     expandIcon={expanded ? <AiOutlineMinus /> : <AiOutlinePlus  />}
                      aria-controls="panel3bh-content"
                      id="panel3bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className="footer-mobile-heading">Collection</span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          <ul className="rcs_footer_list contact-foter2">
                            <li>
                              <NavLink to="/jewelry/fashion-rings">
                                Rings
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/necklaces">
                                Necklaces
                              </NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/earrings">Earrings</NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/pendants">Pendants</NavLink>
                            </li>
                            <li>
                              <NavLink to="/jewelry/bracelets">
                                Bracelets
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion> */}
                  <Accordion
                    expanded={expanded === "panel4"}
                    onChange={handleChange("panel4")}
                  >
                    <AccordionSummary
                      expandIcon={expanded === "panel4" ? <AiOutlineMinus /> : <AiOutlinePlus />}
                      aria-controls="panel4bh-content"
                      id="panel4bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className="footer-mobile-heading">
                        Get in Touch
                      </span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          <ul className="list-none contact-foter2">
                            <li
                              onClick={() => {
                                window.open(Address_details.link, "_blank");
                              }}
                            >

                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                              </svg>

                              {Address_details.textLine1}
                              <br />
                              {Address_details.textLine2}
                            </li>

                            <li
                              onClick={(e) => {
                                window.location.href = contact_number.link;
                              }}
                            >

                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5317 12.4724C15.5208 16.4604 16.4258 11.8467 18.9656 14.3848C21.4143 16.8328 22.8216 17.3232 19.7192 20.4247C19.3306 20.737 16.8616 24.4943 8.1846 15.8197C-0.493478 7.144 3.26158 4.67244 3.57397 4.28395C6.68387 1.17385 7.16586 2.58938 9.61449 5.03733C12.1544 7.5765 7.54266 8.48441 11.5317 12.4724Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                              </svg>


                              {contact_number.text}
                            </li>
                            <li
                              onClick={(e) => {
                                window.location.href = Email_details.link;
                              }}
                            >

                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.9026 8.85107L13.4593 12.4641C12.6198 13.1301 11.4387 13.1301 10.5992 12.4641L6.11841 8.85107" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9089 21C19.9502 21.0084 22 18.5095 22 15.4384V8.57001C22 5.49883 19.9502 3 16.9089 3H7.09114C4.04979 3 2 5.49883 2 8.57001V15.4384C2 18.5095 4.04979 21.0084 7.09114 21H16.9089Z" stroke="#130F26" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round" />
                              </svg>

                              {Email_details.text}
                            </li>

                          </ul>
                        </div>

                      </Typography>
                    </AccordionDetails>
                  </Accordion>

                  <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary
                      expandIcon={expanded === 'panel5' ? <AiOutlineMinus /> : <AiOutlinePlus />}
                      aria-controls="panel4bh-content"
                      id="panel4bh-header"
                      className="rcs_footer_t_color_white"
                    >
                      <span className='footer-mobile-heading'>Store Open Hours</span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <div className="block-footer3">
                          {/* <h2 className="mb-3">Store Open Hours</h2> */}
                          <ul className="list-none contact-foter2">
                            <li>
                              Mon - Thu: 11:30 AM - 4:30 PM
                            </li>
                            <li>Fri: 11:30 AM - 5:00 PM</li>
                            <li>Sat: 10:30 AM - 5:00 PM</li>
                            <li>Sun: Closed</li>
                          </ul>
                        </div>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Row>
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <div className=" footer_logo_box1">
                    <a href="javascript:void(0);"><Image src={recommendsImg} className="img-fluid" alt="Certified logo" /></a>
                    <a href="javascript:void(0);">  <Image src={knotImg} className="img-fluid" alt="Certified logo" /></a>
                    </div>
                    <div className="footer_logo_box2">
                      <a href="https://www.najaappraisers.com/"><Image src={naja} className="img-fluid" alt="Certified logo" /> </a>
                      <a href="https://www.stuller.com/"><Image src={stuller} className="img-fluid" alt="Certified logo" /> </a>
                      <a href="https://www.gia.edu/"><Image src={gia} className="img-fluid" alt="Certified logo" /></a>
                      <a href="javascript:void(0);"><Image src={association} className="img-fluid" alt="Certified logo" /></a>
                      <a href="https://www.jewelers.org/"><Image src={jAmerica} className="img-fluid" alt="Certified logo" /> </a>
                      <a href="javascript:void(0);"><Image src={jbt} className="img-fluid" alt="Certified logo" />  </a>
                      <a href="javascript:void(0);"><Image src={jm} className="img-fluid" alt="Certified logo" /> </a>
                      <a href="https://www.expertise.com/self-care-and-style"><Image src={ma_boston} className="img-fluid" alt="Certified logo" /></a>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>

          <div className="rcs_footer p-0">
            <Container className="showcase-container rcs_custom_home_container ">
              <div className="rcs_footer_bottom border-top " id="rcs_footer_bottom" >
                <Row className="w-100 m-auto justify-content-center">
                  <Col lg={12} md={12} className="p-0">
                    <div className="rcs_footer_bottom_content">
                      <p className="text-center">
                        {" "}
                        Copyright © {new Date().getFullYear()}{" "}
                        {client_name.c_name} All Rights Reserved. | Designed &
                        Developed by <a href="https://belgiumwebnet.com/">Belgium Webnet</a>
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>


          <Container>
            <div className="seo_urlsss">
              <ul>
                <li>
                  <a href={`${helmet_url}/jewelry/bracelets`}>
                    https://showcase.demobw.com/jewelry/bracelets
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/fashion-rings`}>
                    https://showcase.demobw.com/jewelry/fashion-rings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/necklaces`}>
                    https://showcase.demobw.com/jewelry/necklaces
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/blog`}>
                    https://showcase.demobw.com/blog
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education`}>
                    https://showcase.demobw.com/education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/earrings`}>
                    https://showcase.demobw.com/jewelry/earrings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/pendants`}>
                    https://showcase.demobw.com/jewelry/pendants
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/`}>https://showcase.demobw.com/</a>
                </li>
                <li>
                  <a href={`${helmet_url}/contact`}>
                    https://showcase.demobw.com/contact
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/faq`}>
                    https://showcase.demobw.com/faq
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/our-story`}>
                    https://showcase.demobw.com/our-story
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/privacy-policy`}>
                    https://showcase.demobw.com/privacy-policy
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/terms-and-conditions`}>
                    https://showcase.demobw.com/terms-and-conditions
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds`}>
                    https://showcase.demobw.com/diamonds
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ringsettings/diamonds`}>
                    https://showcase.demobw.com/ringsettings/diamonds
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstones`}>
                    https://showcase.demobw.com/gemstones
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds/lab`}>
                    https://showcase.demobw.com/diamonds/lab
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/engagement-ring-education`}>
                    https://showcase.demobw.com/education/engagement-ring-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/fine-jewelry-education`}>
                    https://showcase.demobw.com/education/fine-jewelry-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/gemstone-education`}>
                    https://showcase.demobw.com/education/gemstone-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/loose-diamonds-education`}>
                    https://showcase.demobw.com/education/loose-diamonds-education
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education/wedding-ring-education`}>
                    https://showcase.demobw.com/education/wedding-ring-education
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon1`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon1
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon2`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon2
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon3`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon3
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones-turquoise-tanzanite-and-zircon5`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones-turquoise-tanzanite-and-zircon5
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/december-birthstones:-turquoise,-tanzanite,-and-zircon`}
                  >
                    https://showcase.demobw.com/blog-details/december-birthstones:-turquoise,-tanzanite,-and-zircon
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/blog-details/the-most-amazing-halloween-themed-wedding`}
                  >
                    https://showcase.demobw.com/blog-details/the-most-amazing-halloween-themed-wedding
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/fancy-color-diamond`}>
                    https://showcase.demobw.com/fancy-color-diamond
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/13875`}>
                    https://showcase.demobw.com/diamonds-details/13875
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/13993AA`}>
                    https://showcase.demobw.com/diamonds-details/13993AA
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14025A`}>
                    https://showcase.demobw.com/diamonds-details/14025A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14037AA`}>
                    https://showcase.demobw.com/diamonds-details/14037AA
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14226`}>
                    https://showcase.demobw.com/diamonds-details/14226
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/14797`}>
                    https://showcase.demobw.com/diamonds-details/14797
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15002A`}>
                    https://showcase.demobw.com/diamonds-details/15002A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15422`}>
                    https://showcase.demobw.com/diamonds-details/15422
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15456`}>
                    https://showcase.demobw.com/diamonds-details/15456
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-194863`}>
                    https://showcase.demobw.com/gemstone-details/0157-194863
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-225746`}>
                    https://showcase.demobw.com/gemstone-details/0157-225746
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-271829`}>
                    https://showcase.demobw.com/gemstone-details/0157-271829
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-383030`}>
                    https://showcase.demobw.com/gemstone-details/0157-383030
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-411244`}>
                    https://showcase.demobw.com/gemstone-details/0157-411244
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-428372`}>
                    https://showcase.demobw.com/gemstone-details/0157-428372
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-461540`}>
                    https://showcase.demobw.com/gemstone-details/0157-461540
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-471837`}>
                    https://showcase.demobw.com/gemstone-details/0157-471837
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-708913`}>
                    https://showcase.demobw.com/gemstone-details/0157-708913
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-887513`}>
                    https://showcase.demobw.com/gemstone-details/0157-887513
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-907190`}>
                    https://showcase.demobw.com/gemstone-details/0157-907190
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0157-943809`}>
                    https://showcase.demobw.com/gemstone-details/0157-943809
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400004`}>
                    https://showcase.demobw.com/diamonds-details/400004
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400020`}>
                    https://showcase.demobw.com/diamonds-details/400020
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400021`}>
                    https://showcase.demobw.com/diamonds-details/400021
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400026`}>
                    https://showcase.demobw.com/diamonds-details/400026
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400049`}>
                    https://showcase.demobw.com/diamonds-details/400049
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400052`}>
                    https://showcase.demobw.com/diamonds-details/400052
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400073`}>
                    https://showcase.demobw.com/diamonds-details/400073
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400081`}>
                    https://showcase.demobw.com/diamonds-details/400081
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400115`}>
                    https://showcase.demobw.com/diamonds-details/400115
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400209`}>
                    https://showcase.demobw.com/diamonds-details/400209
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/fancy-color-diamond-detail/1009-1376`}
                  >
                    https://showcase.demobw.com/fancy-color-diamond-detail/1009-1376
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/"https://showcase.demobw.com`}>
                    https://showcase.demobw.com
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/2021-gift-guide`}>
                    https://showcase.demobw.com/2021-gift-guide
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/account/myaccount`}>
                    https://showcase.demobw.com/account/myaccount
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ada-compliance`}>
                    https://showcase.demobw.com/ada-compliance
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/careers`}>
                    https://showcase.demobw.com/careers
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/cart`}>
                    https://showcase.demobw.com/cart
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/charities`}>
                    https://showcase.demobw.com/charities
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/checkout-shipping`}>
                    https://showcase.demobw.com/checkout-shipping
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/complete-diamond-ring`}>
                    https://showcase.demobw.com/complete-diamond-ring
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/complete-fancycolor-ring`}>
                    https://showcase.demobw.com/complete-fancycolor-ring
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/complete-gemstone-ring`}>
                    https://showcase.demobw.com/complete-gemstone-ring
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/custom-design`}>
                    https://showcase.demobw.com/custom-design
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15551A`}>
                    https://showcase.demobw.com/diamonds-details/15551A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/15708`}>
                    https://showcase.demobw.com/diamonds-details/15708
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16472`}>
                    https://showcase.demobw.com/diamonds-details/16472
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16511`}>
                    https://showcase.demobw.com/diamonds-details/16511
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16545`}>
                    https://showcase.demobw.com/diamonds-details/16545
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/16632`}>
                    https://showcase.demobw.com/diamonds-details/16632
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/400225`}>
                    https://showcase.demobw.com/diamonds-details/400225
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/T9321A`}>
                    https://showcase.demobw.com/diamonds-details/T9321A
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/T9376`}>
                    https://showcase.demobw.com/diamonds-details/T9376
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/diamonds-details/V21164`}>
                    https://showcase.demobw.com/diamonds-details/V21164
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education-diamond-buying`}>
                    https://showcase.demobw.com/education-diamond-buying
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education-gold-buying`}>
                    https://showcase.demobw.com/education-gold-buying
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/education-jewelry-care`}>
                    https://showcase.demobw.com/education-jewelry-care
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/educational-blog`}>
                    https://showcase.demobw.com/educational-blog
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/financing`}>
                    https://showcase.demobw.com/financing
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-121024`}>
                    https://showcase.demobw.com/gemstone-details/0910-121024
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-185890`}>
                    https://showcase.demobw.com/gemstone-details/0910-185890
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-300380`}>
                    https://showcase.demobw.com/gemstone-details/0910-300380
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-356235`}>
                    https://showcase.demobw.com/gemstone-details/0910-356235
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-397620`}>
                    https://showcase.demobw.com/gemstone-details/0910-397620
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-841228`}>
                    https://showcase.demobw.com/gemstone-details/0910-841228
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-866863`}>
                    https://showcase.demobw.com/gemstone-details/0910-866863
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0910-951576`}>
                    https://showcase.demobw.com/gemstone-details/0910-951576
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0911-140198`}>
                    https://showcase.demobw.com/gemstone-details/0911-140198
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0911-171542`}>
                    https://showcase.demobw.com/gemstone-details/0911-171542
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/gemstone-details/0911-303949`}>
                    https://showcase.demobw.com/gemstone-details/0911-303949
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/indian-jewelry`}>
                    https://showcase.demobw.com/indian-jewelry
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/insurance`}>
                    https://showcase.demobw.com/insurance
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/jewelry/wedding-rings`}>
                    https://showcase.demobw.com/jewelry/wedding-rings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/military-discount`}>
                    https://showcase.demobw.com/military-discount
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/mission-and-vision`}>
                    https://showcase.demobw.com/mission-and-vision
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/press-media`}>
                    https://showcase.demobw.com/press-media
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/productdetail/14k-rose-freeform-ring-5808122623p`}
                  >
                    https://showcase.demobw.com/productdetail/14k-rose-freeform-ring-5808122623p
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/register`}>
                    https://showcase.demobw.com/register
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/responsible-sourcing`}>
                    https://showcase.demobw.com/responsible-sourcing
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/returns-and-exchanges`}>
                    https://showcase.demobw.com/returns-and-exchanges
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-4-mm-round-16-ctw-diamond-semi-set-engagement-ring--12196560010p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-4-mm-round-16-ctw-diamond-semi-set-engagement-ring--12196560010p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-52-mm-round-13-ctw-diamond-semi-set-halo-style-engagement-ring-122467600p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-52-mm-round-13-ctw-diamond-semi-set-halo-style-engagement-ring-122467600p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-55-mm-square-110-ctw-diamond-semi-set-engagement-ring---12197060080p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-55-mm-square-110-ctw-diamond-semi-set-engagement-ring---12197060080p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-55x55-mm-square-13-ctw-diamond-semi-set-engagement-ring--122769600p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-55x55-mm-square-13-ctw-diamond-semi-set-engagement-ring--122769600p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-58-mm-round-13-ctw-diamond-semi-set-engagement-ring-12284260000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-58-mm-round-13-ctw-diamond-semi-set-engagement-ring-12284260000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-58-mm-round-18-ctw-diamond-semi-set-engagement-ring---12197960000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-58-mm-round-18-ctw-diamond-semi-set-engagement-ring---12197960000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-5x5-mm-square-06-ctw-diamond-semi-set-engagement-ring-12281560000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-5x5-mm-square-06-ctw-diamond-semi-set-engagement-ring-12281560000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-65-mm-round-13-ctw-diamond-semi-set-engagement-ring---12196760012p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-65-mm-round-13-ctw-diamond-semi-set-engagement-ring---12196760012p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-6x6-mm-cushion-15-ctw-diamond-semi-set-engagement-ring-12198460001p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-6x6-mm-cushion-15-ctw-diamond-semi-set-engagement-ring-12198460001p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-7x5-mm-emerald-08-ctw-diamond-semi-set-engagement-ring-651582101p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-7x5-mm-emerald-08-ctw-diamond-semi-set-engagement-ring-651582101p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-white-8x45-mm-marquise-13-ctw-diamond-semi-set-engagement-ring-1220406000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-white-8x45-mm-marquise-13-ctw-diamond-semi-set-engagement-ring-1220406000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-yellow-65-mm-round-04-ctw-diamond-semi-set-engagement-ring-12279760000p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-yellow-65-mm-round-04-ctw-diamond-semi-set-engagement-ring-12279760000p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/14k-yellowwhite-65-mm-round-13-ctw-diamond-semi-set-engagement-ring-651697100p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/14k-yellowwhite-65-mm-round-13-ctw-diamond-semi-set-engagement-ring-651697100p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/continuum-sterling-silver-58-mm-round-cubic-zirconia-solitaire-ring-121968108p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/continuum-sterling-silver-58-mm-round-cubic-zirconia-solitaire-ring-121968108p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/platinum-65-mm-round-12-ctw-diamond-semi-set-engagement-ring--651721102p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/platinum-65-mm-round-12-ctw-diamond-semi-set-engagement-ring--651721102p
                  </a>
                </li>
                <li>
                  <a
                    href={`${helmet_url}/ringsettingdetail/setting/platinum-65-mm-round-15-ctw-diamond-semi-set-engagement-ring-1227006002p`}
                  >
                    https://showcase.demobw.com/ringsettingdetail/setting/platinum-65-mm-round-15-ctw-diamond-semi-set-engagement-ring-1227006002p
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ringsettings`}>
                    https://showcase.demobw.com/ringsettings
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/ringsettings/style=Vintage`}>
                    https://showcase.demobw.com/ringsettings/style=Vintage
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/sell-your-jewelry`}>
                    https://showcase.demobw.com/sell-your-jewelry
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/services`}>
                    https://showcase.demobw.com/services
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/testimonials`}>
                    https://showcase.demobw.com/testimonials
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/warranty-and-guarantees`}>
                    https://showcase.demobw.com/warranty-and-guarantees
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/watches`}>
                    https://showcase.demobw.com/watches
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/wishlist`}>
                    https://showcase.demobw.com/wishlist
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/`}>https://showcase.demobw.com/</a>
                </li>
                <li>
                  <a href={`${helmet_url}/robots.txt`}>
                    https://showcase.demobw.com/robots.txt
                  </a>
                </li>
                <li>
                  <a href={`${helmet_url}/sitemap.xml`}>
                    https://showcase.demobw.com/sitemap.xml
                  </a>
                </li>
              </ul>
            </div>
          </Container>
          {/* Whatsapp Chat */}
          {/* <a href="https://wa.me/+16469929024" class="whatsapp_float" target="_blank" rel="noopener noreferrer">
        <Image src={whatsapp} alt="whatspp chat"></Image>
      </a> */}
          {/* Whatsapp Chat */}
          {/* <div className='rcs_footer_chat'>
        <div className='rcs_diamond_specialist'>

        </div>
        <div className='rcs_diamond_tdo_chat'>

        </div>
      </div> */}
        </div>
    </div>
  );
};
export default Footer;
